import Reveal from "@/components/base/Reveal";

interface ExperiencesListHelpProps {
  onEnquire: () => void;
}

export default function ExperiencesListHelp({ onEnquire }: ExperiencesListHelpProps) {
  return (
    <section className="sun-glaze bg-background-50 pt-12 md:pt-16">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-6 md:p-8 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-8">
            <span className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 shrink-0">
              <i className="ri-compass-3-line text-3xl"></i>
            </span>
            <div className="flex-1 min-w-0">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950 font-semibold">
                Not sure where to start?
              </h2>
              <p className="mt-2 text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl">
                Tell us your dates, your group and what you're curious about — we'll suggest the
                experiences and farmers that fit you best, so you can decide with confidence before
                you pick.
              </p>
            </div>
            <button
              type="button"
              onClick={onEnquire}
              className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 text-sm font-semibold px-7 py-4 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer shrink-0"
            >
              <i className="ri-chat-smile-2-line text-lg"></i>
              Help Me Choose
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}